(function(global, factory) {
    typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require("path-to-regexp"), require("react"), require("axios"), require("jsonpointer"), require("react-html-parser")) : typeof define === "function" && define.amd ? define([ "exports", "path-to-regexp", "react", "axios", "jsonpointer", "react-html-parser" ], factory) : (global = global || self, 
    factory(global.BloomreachReactSdk = {}, global.pathToRegexp, global.React, global.axios, global.jsonpointer, global.ReactHtmlParser));
})(this, (function(exports, pathToRegexp, React, axios, jsonpointer, ReactHtmlParser) {
    "use strict";
    pathToRegexp = pathToRegexp && pathToRegexp.hasOwnProperty("default") ? pathToRegexp["default"] : pathToRegexp;
    React = React && React.hasOwnProperty("default") ? React["default"] : React;
    axios = axios && axios.hasOwnProperty("default") ? axios["default"] : axios;
    jsonpointer = jsonpointer && jsonpointer.hasOwnProperty("default") ? jsonpointer["default"] : jsonpointer;
    ReactHtmlParser = ReactHtmlParser && ReactHtmlParser.hasOwnProperty("default") ? ReactHtmlParser["default"] : ReactHtmlParser;
    function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function(obj) {
                return typeof obj;
            };
        } else {
            _typeof = function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
        }
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }
    function _defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }
        return obj;
    }
    function _extends() {
        _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter((function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            }));
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) {
                ownKeys(Object(source), true).forEach((function(key) {
                    _defineProperty(target, key, source[key]);
                }));
            } else if (Object.getOwnPropertyDescriptors) {
                Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            } else {
                ownKeys(Object(source)).forEach((function(key) {
                    Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                }));
            }
        }
        return target;
    }
    function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
        }
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        if (superClass) _setPrototypeOf(subClass, superClass);
    }
    function _getPrototypeOf(o) {
        _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return _getPrototypeOf(o);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _assertThisInitialized(self) {
        if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }
        return self;
    }
    function _possibleConstructorReturn(self, call) {
        if (call && (typeof call === "object" || typeof call === "function")) {
            return call;
        }
        return _assertThisInitialized(self);
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArrayLimit(arr, i) {
        if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
            return;
        }
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally {
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally {
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    var FULLY_QUALIFIED_LINK = /\w+:\/\//;
    var defaultCmsUrls = {
        scheme: "http",
        hostname: "localhost",
        port: "8080",
        contextPath: "site",
        channelPath: "",
        previewPrefix: "_cmsinternal",
        apiPath: "resourceapi",
        apiComponentRenderingUrlSuffix: "?_hn:type=component-rendering&_hn:ref="
    };
    function setUrlsWithDefault() {
        var urls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var defaultUrls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var newUrls = {
            scheme: urls.scheme || defaultUrls.scheme,
            hostname: urls.hostname || defaultUrls.hostname,
            port: urls.port !== undefined ? urls.port : defaultUrls.port,
            contextPath: urls.contextPath !== undefined ? urls.contextPath : defaultUrls.contextPath,
            channelPath: urls.channelPath || defaultUrls.channelPath,
            previewPrefix: urls.previewPrefix !== undefined ? urls.previewPrefix : defaultUrls.previewPrefix,
            apiPath: urls.apiPath || defaultUrls.apiPath,
            apiComponentRenderingUrlSuffix: urls.apiComponentRenderingUrlSuffix || defaultUrls.apiComponentRenderingUrlSuffix
        };
        newUrls.baseUrl = "".concat(newUrls.scheme, "://").concat(newUrls.hostname);
        if (newUrls.port) {
            newUrls.baseUrl = "".concat(newUrls.baseUrl, ":").concat(newUrls.port);
        }
        return newUrls;
    }
    var cmsUrls = {};
    function updateCmsUrls() {
        var urls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (_typeof(urls) !== "object") {
            console.log("Warning! Supplied CMS URLs not of type object. Using default URLs.");
            urls = {};
        }
        cmsUrls.live = setUrlsWithDefault(urls.live, defaultCmsUrls);
        cmsUrls.preview = setUrlsWithDefault(urls.preview, cmsUrls.live);
        var pathregexp = "".concat(cmsUrls.live.contextPath !== "" ? "/:contextPath(".concat(cmsUrls.live.contextPath, ")?") : "") + "/:previewPrefix(".concat(cmsUrls.live.previewPrefix, ")?") + "".concat(cmsUrls.live.channelPath !== "" ? "/:channelPath(".concat(cmsUrls.live.channelPath, ")?") : "") + "/:pathInfo*";
        cmsUrls.regexpKeys = [];
        cmsUrls.regexp = pathToRegexp(pathregexp, cmsUrls.regexpKeys);
        return cmsUrls;
    }
    function buildApiUrl(pathInfo, query, preview, componentId, urls) {
        if (!urls) {
            urls = cmsUrls;
        }
        urls = urls[preview ? "preview" : "live"];
        var url = urls.baseUrl;
        if (urls.contextPath !== "") {
            url += "/".concat(urls.contextPath);
        }
        if (preview && urls.previewPrefix !== "") {
            url += "/".concat(urls.previewPrefix);
        }
        if (urls.channelPath !== "") {
            url += "/".concat(urls.channelPath);
        }
        url += "/".concat(urls.apiPath);
        if (pathInfo) {
            url += "/".concat(pathInfo);
        }
        if (componentId) {
            url += urls.apiComponentRenderingUrlSuffix + componentId;
        }
        if (query) {
            url += (url.includes("?") ? "&" : "?") + query;
        }
        return url;
    }
    function hasPreviewQueryParameter(query) {
        return query.startsWith("bloomreach-preview=true") || query.indexOf("&bloomreach-preview=true") !== -1;
    }
    function isMatchingPreviewHostname(hostname, urls) {
        return urls.live.hostname !== urls.preview.hostname && hostname === urls.preview.hostname;
    }
    function parseRequest() {
        var request = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var urls = arguments.length > 1 ? arguments[1] : undefined;
        if (!urls) {
            urls = cmsUrls;
        }
        var _request$path$split = request.path.split("?", 2), _request$path$split2 = _slicedToArray(_request$path$split, 2), urlPath = _request$path$split2[0], _request$path$split2$ = _request$path$split2[1], query = _request$path$split2$ === void 0 ? "" : _request$path$split2$;
        var _request$hostname$spl = request.hostname.split(":", 2), _request$hostname$spl2 = _slicedToArray(_request$hostname$spl, 1), hostname = _request$hostname$spl2[0];
        var results = urls.regexp.exec(urlPath);
        var preview = hasPreviewQueryParameter(query) || isMatchingPreviewHostname(hostname, urls);
        if (!preview && results) {
            var previewIdx = urls.regexpKeys.findIndex((function(obj) {
                return obj.name === "previewPrefix";
            }));
            preview = results[previewIdx + 1] !== undefined;
        }
        var path = "";
        if (results) {
            var pathIdx = urls.regexpKeys.findIndex((function(obj) {
                return obj.name === "pathInfo";
            }));
            path = results[pathIdx + 1] || "";
        }
        return {
            path: path,
            preview: preview,
            query: query
        };
    }
    function getApiUrl(request) {
        var newCmsUrls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cmsUrls = updateCmsUrls(newCmsUrls);
        var parsedRequest = parseRequest(request, cmsUrls);
        return buildApiUrl(parsedRequest.path, parsedRequest.query, parsedRequest.preview, null, cmsUrls);
    }
    updateCmsUrls();
    var PageModelContext = React.createContext({});
    var PreviewContext = React.createContext("");
    var ComponentDefinitionsContext = React.createContext({});
    var CreateLinkContext = React.createContext();
    function withPageModel(Component) {
        return function PageModelComponent(props) {
            return React.createElement(PageModelContext.Consumer, null, (function(pageModel) {
                return React.createElement(Component, _extends({}, props, {
                    pageModel: pageModel
                }));
            }));
        };
    }
    function getNestedObject(nestedObj, pathArr) {
        return pathArr.reduce((function(obj, key) {
            return obj && obj[key] !== "undefined" ? obj[key] : null;
        }), nestedObj);
    }
    function addBeginComment(htmlElm, position, configuration, preview) {
        var beginNodeSpan = getNestedObject(configuration, [ "_meta", "beginNodeSpan", 0, "data" ]);
        if (!preview || !htmlElm || !beginNodeSpan || htmlElm.classList.contains("cms-begin-comment-added")) {
            return;
        }
        htmlElm.insertAdjacentHTML(position, configuration._meta.beginNodeSpan[0].data);
        htmlElm.classList.add("cms-begin-comment-added");
    }
    function addEndComment(htmlElm, position, configuration, preview) {
        var endNodeSpan = getNestedObject(configuration, [ "_meta", "endNodeSpan", 0, "data" ]);
        if (!preview || !htmlElm || !endNodeSpan || htmlElm.classList.contains("cms-end-comment-added")) {
            return;
        }
        htmlElm.insertAdjacentHTML(position, configuration._meta.endNodeSpan[0].data);
        htmlElm.classList.add("cms-end-comment-added");
    }
    function addBodyComments(configuration, preview) {
        var endNodeSpan = getNestedObject(configuration, [ "_meta", "endNodeSpan", 0, "data" ]);
        if (!preview || !endNodeSpan) {
            return;
        }
        var pageMetaDataElm = document.getElementById("hst-page-meta-data");
        if (pageMetaDataElm) {
            pageMetaDataElm.innerHTML = "";
        } else {
            pageMetaDataElm = document.createElement("div");
            pageMetaDataElm.id = "hst-page-meta-data";
            pageMetaDataElm.style = "display: none";
            document.body.appendChild(pageMetaDataElm);
        }
        configuration._meta.endNodeSpan.forEach((function(_ref) {
            var data = _ref.data;
            return pageMetaDataElm.insertAdjacentHTML("beforeend", data);
        }));
    }
    function _catch(body, recover) {
        try {
            var result = body();
        } catch (e) {
            return recover(e);
        }
        if (result && result.then) {
            return result.then(void 0, recover);
        }
        return result;
    }
    var fetchUrl = function fetchUrl(url, requestConfig) {
        try {
            var _exit2 = false;
            var _temp2 = _catch((function() {
                return Promise.resolve(axios(url, requestConfig)).then((function(_ref) {
                    var data = _ref.data;
                    _exit2 = true;
                    return data;
                }));
            }), (function(error) {
                if (error.response) {
                    console.log("Error! Status code ".concat(error.response.status, " while fetching CMS page data for URL: ").concat(url));
                    console.log(error.response.data);
                    console.log(error.response.headers);
                } else if (error.request) {
                    console.log(error.request);
                } else {
                    console.log("Error while fetching CMS page data for URL:".concat(url), error.message);
                }
                console.log(error.config);
            }));
            return Promise.resolve(_temp2 && _temp2.then ? _temp2.then((function(_result) {
                return _exit2 ? _result : null;
            })) : _exit2 ? _temp2 : null);
        } catch (e) {
            return Promise.reject(e);
        }
    };
    var requestConfigGet = {
        method: "GET",
        withCredentials: true
    };
    var requestConfigPost = {
        method: "POST",
        withCredentials: true,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    };
    function fetchCmsPage(pathInfo, query, preview, cmsUrls) {
        var url = buildApiUrl(pathInfo, query, preview, null, cmsUrls);
        return fetchUrl(url, requestConfigGet);
    }
    function toUrlEncodedFormData(json) {
        return Object.keys(json).map((function(key) {
            return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(json[key]));
        })).join("&");
    }
    function fetchComponentUpdate(pathInfo, query, preview, componentId, body) {
        var requestConfig = _objectSpread2({
            data: toUrlEncodedFormData(body)
        }, requestConfigPost);
        var url = buildApiUrl(pathInfo, query, preview, componentId);
        return fetchUrl(url, requestConfig);
    }
    function findChildById(object, id, parent, idx) {
        var props = Object.keys(object);
        for (var i = 0; i < props.length; i++) {
            var prop = props[i];
            if (_typeof(object[prop]) === "object" && object[prop] !== null) {
                var result = findChildById(object[prop], id, object, prop);
                if (result) {
                    return result;
                }
            } else if (prop === "id" && object.id === id) {
                return {
                    parent: parent,
                    idx: idx
                };
            }
        }
        return null;
    }
    var CmsPage = function(_React$Component) {
        _inherits(CmsPage, _React$Component);
        function CmsPage(props) {
            var _this;
            _classCallCheck(this, CmsPage);
            _this = _possibleConstructorReturn(this, _getPrototypeOf(CmsPage).call(this, props));
            updateCmsUrls(_this.props.cmsUrls);
            _this.state = parseRequest(_this.props.request);
            _this.state.createLink = _this.props.createLink;
            if (_typeof(_this.props.componentDefinitions) === "object") {
                _this.state.componentDefinitions = _this.props.componentDefinitions;
            }
            if (_this.props.pageModel) {
                _this.state.pageModel = _this.props.pageModel;
            }
            return _this;
        }
        _createClass(CmsPage, [ {
            key: "fetchPageModel",
            value: function fetchPageModel(path, query, preview) {
                try {
                    var _this3 = this;
                    if (_this3.props.debug) {
                        console.log("### React SDK debugging ### fetching page model for URL-path '%s'", path);
                    }
                    return Promise.resolve(fetchCmsPage(path, query, preview)).then((function(data) {
                        _this3.updatePageModel(data);
                    }));
                } catch (e) {
                    return Promise.reject(e);
                }
            }
        }, {
            key: "updatePageModel",
            value: function updatePageModel(pageModel) {
                if (pageModel) {
                    addBodyComments(pageModel.page, this.state.preview);
                }
                this.setState({
                    pageModel: pageModel
                });
                if (this.state.preview && this.cms && typeof this.cms.createOverlay === "function") {
                    if (this.props.debug) {
                        console.log("### React SDK debugging ### creating CMS overlay");
                    }
                    this.cms.createOverlay();
                }
            }
        }, {
            key: "initializeCmsIntegration",
            value: function initializeCmsIntegration() {
                var _this4 = this;
                if (!this.state.preview || typeof window === "undefined") {
                    return;
                }
                window.SPA = {
                    renderComponent: this.updateComponent.bind(this),
                    init: function init(cms) {
                        _this4.cms = cms;
                        if (_this4.state.pageModel) {
                            if (_this4.props.debug) {
                                console.log("### React SDK debugging ### creating CMS overlay");
                            }
                            cms.createOverlay();
                        }
                    }
                };
            }
        }, {
            key: "updateComponent",
            value: function updateComponent(componentId, propertiesMap) {
                try {
                    var _this6 = this;
                    if (_this6.props.debug) {
                        console.log("### React SDK debugging ### component update triggered for '%s' with properties:", componentId);
                        console.dir(propertiesMap);
                    }
                    var componentToUpdate = findChildById(_this6.state.pageModel, componentId);
                    if (componentToUpdate == null) {
                        return Promise.resolve();
                    }
                    return Promise.resolve(fetchComponentUpdate(_this6.state.path, _this6.state.query, _this6.state.preview, componentId, propertiesMap)).then((function(response) {
                        if (!response) {
                            return;
                        }
                        if (response.page) {
                            componentToUpdate.parent[componentToUpdate.idx] = response.page;
                        }
                        var pageModel = _objectSpread2({}, _this6.state.pageModel);
                        if (response.content) {
                            pageModel.content = _objectSpread2({}, pageModel.content, {}, response.content);
                        }
                        _this6.setState({
                            pageModel: pageModel
                        });
                    }));
                } catch (e) {
                    return Promise.reject(e);
                }
            }
        }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.pageModel !== prevProps.pageModel) {
                    this.updatePageModel(this.props.pageModel);
                } else if (this.props.request.path !== prevProps.request.path) {
                    var parsedUrl = parseRequest(this.props.request);
                    this.fetchPageModel(parsedUrl.path, parsedUrl.query, parsedUrl.preview);
                }
                if (this.state.pageModel !== prevState.pageModel && this.cms) {
                    this.cms.createOverlay();
                }
            }
        }, {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.initializeCmsIntegration();
                if (!this.state.pageModel) {
                    this.fetchPageModel(this.state.path, this.state.query, this.state.preview);
                } else {
                    addBodyComments(this.state.pageModel.page, this.state.preview);
                }
            }
        }, {
            key: "render",
            value: function render() {
                var pageModel = this.state.pageModel;
                if (!pageModel || !pageModel.page) {
                    return null;
                }
                return React.createElement(ComponentDefinitionsContext.Provider, {
                    value: this.state.componentDefinitions
                }, React.createElement(PageModelContext.Provider, {
                    value: pageModel
                }, React.createElement(PreviewContext.Provider, {
                    value: this.state.preview
                }, React.createElement(CreateLinkContext.Provider, {
                    value: this.state.createLink
                }, typeof this.props.children === "function" ? this.props.children() : this.props.children))));
            }
        } ]);
        return CmsPage;
    }(React.Component);
    var Placeholder = function(_React$Component) {
        _inherits(Placeholder, _React$Component);
        function Placeholder() {
            _classCallCheck(this, Placeholder);
            return _possibleConstructorReturn(this, _getPrototypeOf(Placeholder).apply(this, arguments));
        }
        _createClass(Placeholder, [ {
            key: "render",
            value: function render() {
                return React.createElement("p", null, "Click to configure ", this.props.name);
            }
        } ]);
        return Placeholder;
    }(React.Component);
    var UndefinedComponent = function(_React$Component) {
        _inherits(UndefinedComponent, _React$Component);
        function UndefinedComponent() {
            _classCallCheck(this, UndefinedComponent);
            return _possibleConstructorReturn(this, _getPrototypeOf(UndefinedComponent).apply(this, arguments));
        }
        _createClass(UndefinedComponent, [ {
            key: "render",
            value: function render() {
                return React.createElement("p", null, "Component ", this.props.name, " ", React.createElement("strong", null, "not defined"));
            }
        } ]);
        return UndefinedComponent;
    }(React.Component);
    var CmsEditButton = function(_React$Component) {
        _inherits(CmsEditButton, _React$Component);
        function CmsEditButton(props) {
            var _this;
            _classCallCheck(this, CmsEditButton);
            _this = _possibleConstructorReturn(this, _getPrototypeOf(CmsEditButton).call(this, props));
            _this.placeholder = React.createRef();
            return _this;
        }
        _createClass(CmsEditButton, [ {
            key: "addButton",
            value: function addButton(htmlElm) {
                var _this$props = this.props, configuration = _this$props.configuration, preview = _this$props.preview;
                addBeginComment(htmlElm, "afterbegin", configuration, preview);
            }
        }, {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var path = [ "_meta", "beginNodeSpan", 0, "data" ];
                return getNestedObject(this.props.configuration, path) !== getNestedObject(nextProps.configuration, path);
            }
        }, {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.placeholder.current) {
                    return;
                }
                this.addButton(this.placeholder.current);
            }
        }, {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var placeholder = this.placeholder.current;
                if (!placeholder) {
                    return;
                }
                Array.from(placeholder.childNodes).forEach((function(node) {
                    return node.remove();
                }));
                placeholder.removeAttribute("class");
                this.addButton(placeholder);
            }
        }, {
            key: "render",
            value: function render() {
                if (!this.props.preview) {
                    return null;
                }
                return React.createElement("div", {
                    style: {
                        position: "relative"
                    }
                }, React.createElement("span", {
                    ref: this.placeholder
                }));
            }
        } ]);
        return CmsEditButton;
    }(React.Component);
    var ContentComponentWrapper = function(_React$Component) {
        _inherits(ContentComponentWrapper, _React$Component);
        function ContentComponentWrapper() {
            _classCallCheck(this, ContentComponentWrapper);
            return _possibleConstructorReturn(this, _getPrototypeOf(ContentComponentWrapper).apply(this, arguments));
        }
        _createClass(ContentComponentWrapper, [ {
            key: "renderContentComponentWrapper",
            value: function renderContentComponentWrapper(component, pageModel, content, preview, componentDefinitions, manageContentButton) {
                if (component.label in componentDefinitions && componentDefinitions[component.label].component) {
                    return React.createElement(componentDefinitions[component.label].component, {
                        content: content,
                        pageModel: pageModel,
                        preview: preview,
                        manageContentButton: manageContentButton
                    }, null);
                }
                return React.createElement(UndefinedComponent, {
                    name: component.label
                });
            }
        }, {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, configuration = _this$props.configuration, pageModel = _this$props.pageModel, preview = _this$props.preview;
                var contentRef = getNestedObject(configuration, [ "models", "document", "$ref" ]);
                var content;
                if (!contentRef) {
                    contentRef = this.props.contentRef;
                }
                if (contentRef && (typeof contentRef === "string" || contentRef instanceof String)) {
                    content = jsonpointer.get(pageModel, contentRef);
                }
                if (!content && preview) {
                    return React.createElement(Placeholder, {
                        name: configuration.label
                    });
                }
                if (!content) {
                    return null;
                }
                var manageContentButton = preview ? React.createElement(CmsEditButton, {
                    configuration: content,
                    preview: preview
                }) : null;
                return React.createElement(ComponentDefinitionsContext.Consumer, null, (function(componentDefinitions) {
                    return _this.renderContentComponentWrapper(configuration, pageModel, content, preview, componentDefinitions, manageContentButton);
                }));
            }
        } ]);
        return ContentComponentWrapper;
    }(React.Component);
    var CmsContainerItem = function(_React$Component) {
        _inherits(CmsContainerItem, _React$Component);
        function CmsContainerItem() {
            _classCallCheck(this, CmsContainerItem);
            return _possibleConstructorReturn(this, _getPrototypeOf(CmsContainerItem).apply(this, arguments));
        }
        _createClass(CmsContainerItem, [ {
            key: "renderContainerItem",
            value: function renderContainerItem(configuration, pageModel, preview, componentDefinitions) {
                var _this = this;
                if (preview && configuration) {
                    return React.createElement("div", {
                        className: "hst-container-item",
                        ref: function ref(containerItemElm) {
                            _this.addMetaData(containerItemElm, configuration, preview);
                        }
                    }, this.renderContainerItemComponent(configuration, pageModel, preview, componentDefinitions));
                }
                if (configuration) {
                    return this.renderContainerItemComponent(configuration, pageModel, preview, componentDefinitions);
                }
                return null;
            }
        }, {
            key: "renderContainerItemComponent",
            value: function renderContainerItemComponent(component, pageModel, preview, componentDefinitions) {
                if (!(component.label in componentDefinitions)) {
                    return React.createElement(UndefinedComponent, {
                        name: component.label
                    });
                }
                var componentDefinition = componentDefinitions[component.label];
                if ("wrapInContentComponent" in componentDefinition && componentDefinition.wrapInContentComponent) {
                    return React.createElement(ContentComponentWrapper, {
                        configuration: component,
                        pageModel: pageModel,
                        preview: preview,
                        componentDefinitions: componentDefinitions
                    });
                }
                if (componentDefinition.component) {
                    return React.createElement(componentDefinition.component, {
                        configuration: component,
                        pageModel: pageModel,
                        preview: preview,
                        componentDefinitions: componentDefinitions
                    }, null);
                }
                return null;
            }
        }, {
            key: "addMetaData",
            value: function addMetaData(htmlElm, configuration, preview) {
                addBeginComment(htmlElm, "afterbegin", configuration, preview);
                addEndComment(htmlElm, "beforeend", configuration, preview);
            }
        }, {
            key: "render",
            value: function render() {
                var _this2 = this;
                var configuration = this.props.configuration;
                return React.createElement(PageModelContext.Consumer, null, (function(pageModel) {
                    return React.createElement(PreviewContext.Consumer, null, (function(preview) {
                        return React.createElement(ComponentDefinitionsContext.Consumer, null, (function(componentDefinitions) {
                            return _this2.renderContainerItem(configuration, pageModel, preview, componentDefinitions);
                        }));
                    }));
                }));
            }
        } ]);
        return CmsContainerItem;
    }(React.Component);
    var CmsContainer = function(_React$Component) {
        _inherits(CmsContainer, _React$Component);
        function CmsContainer() {
            _classCallCheck(this, CmsContainer);
            return _possibleConstructorReturn(this, _getPrototypeOf(CmsContainer).apply(this, arguments));
        }
        _createClass(CmsContainer, [ {
            key: "renderContainerWrapper",
            value: function renderContainerWrapper(configuration, pageModel, preview, componentDefinitions) {
                var _this = this;
                if (preview) {
                    return React.createElement("div", null, React.createElement("div", {
                        className: "hst-container",
                        ref: function ref(containerElm) {
                            _this.addMetaData(containerElm, configuration, preview);
                        }
                    }, this.renderContainer(configuration, pageModel, preview, componentDefinitions)));
                }
                return this.renderContainer(configuration, pageModel, preview, componentDefinitions);
            }
        }, {
            key: "renderContainer",
            value: function renderContainer() {
                var configuration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    components: []
                };
                var pageModel = arguments.length > 1 ? arguments[1] : undefined;
                var preview = arguments.length > 2 ? arguments[2] : undefined;
                var componentDefinitions = arguments.length > 3 ? arguments[3] : undefined;
                var components = configuration.components, label = configuration.label;
                if (!components || !components.length) {
                    return null;
                }
                var containerItemComponents = components.map((function(component) {
                    return React.createElement(CmsContainerItem, {
                        configuration: component,
                        key: component.id
                    });
                }));
                var ContainerComponent = componentDefinitions[label] && componentDefinitions[label].component;
                if (!ContainerComponent) {
                    return React.createElement(React.Fragment, null, containerItemComponents);
                }
                return React.createElement(ContainerComponent, {
                    configuration: configuration,
                    pageModel: pageModel,
                    preview: preview,
                    componentDefinitions: componentDefinitions
                }, containerItemComponents);
            }
        }, {
            key: "addMetaData",
            value: function addMetaData(htmlElm, configuration, preview) {
                addBeginComment(htmlElm, "beforebegin", configuration, preview);
                addEndComment(htmlElm, "afterend", configuration, preview);
            }
        }, {
            key: "render",
            value: function render() {
                var _this2 = this;
                if (!this.props.configuration) {
                    return null;
                }
                return React.createElement(PageModelContext.Consumer, null, (function(pageModel) {
                    return React.createElement(PreviewContext.Consumer, null, (function(preview) {
                        return React.createElement(ComponentDefinitionsContext.Consumer, null, (function(componentDefinitions) {
                            return _this2.renderContainerWrapper(_this2.props.configuration, pageModel, preview, componentDefinitions);
                        }));
                    }));
                }));
            }
        } ]);
        return CmsContainer;
    }(React.Component);
    var CmsComponent = function(_React$Component) {
        _inherits(CmsComponent, _React$Component);
        function CmsComponent() {
            _classCallCheck(this, CmsComponent);
            return _possibleConstructorReturn(this, _getPrototypeOf(CmsComponent).apply(this, arguments));
        }
        _createClass(CmsComponent, [ {
            key: "render",
            value: function render() {
                var configuration = this.props.configuration;
                if (!configuration || !configuration.components || !configuration.components.length) {
                    return null;
                }
                return React.createElement(React.Fragment, null, configuration.components.map((function(component) {
                    if (component.type === "CONTAINER_COMPONENT") {
                        return React.createElement(CmsContainer, {
                            configuration: component,
                            key: component.id
                        });
                    }
                    return React.createElement(CmsComponent, {
                        configuration: component,
                        key: component.id
                    });
                })));
            }
        } ]);
        return CmsComponent;
    }(React.Component);
    function getConfigurationForPathSegment(pathSegment, configuration) {
        return configuration.components.find((function(component) {
            return pathSegment === component.name || pathSegment === "*";
        })) || null;
    }
    function getConfigurationForPath(path, pageModel) {
        var pathSegments = path.split("/");
        var currPath;
        var configuration = pageModel.page;
        while (getNestedObject(configuration, [ "components", 0 ])) {
            currPath = pathSegments.shift();
            configuration = getConfigurationForPathSegment(currPath, configuration);
            if (configuration && pathSegments.length === 0) {
                return configuration;
            }
        }
        return null;
    }
    var RenderCmsComponent = function(_React$Component) {
        _inherits(RenderCmsComponent, _React$Component);
        function RenderCmsComponent() {
            _classCallCheck(this, RenderCmsComponent);
            return _possibleConstructorReturn(this, _getPrototypeOf(RenderCmsComponent).apply(this, arguments));
        }
        _createClass(RenderCmsComponent, [ {
            key: "renderPageComponent",
            value: function renderPageComponent(configuration) {
                switch (configuration.type) {
                  case "CONTAINER_COMPONENT":
                    return React.createElement(CmsContainer, {
                        configuration: configuration
                    });

                  case "CONTAINER_ITEM_COMPONENT":
                    return React.createElement(CmsContainerItem, {
                        configuration: configuration
                    });

                  default:
                    return React.createElement(CmsComponent, {
                        configuration: configuration
                    });
                }
            }
        }, {
            key: "renderStaticComponent",
            value: function renderStaticComponent(renderComponent, configuration, pageModel) {
                return React.createElement(PreviewContext.Consumer, null, (function(preview) {
                    return React.createElement(renderComponent, {
                        configuration: configuration,
                        pageModel: pageModel,
                        preview: preview
                    });
                }));
            }
        }, {
            key: "render",
            value: function render() {
                var _this$props = this.props, path = _this$props.path, pageModel = _this$props.pageModel, renderComponent = _this$props.renderComponent;
                var configuration;
                if (!path) {
                    if (!pageModel) {
                        console.log("<RenderCmsComponent> has no supplied page model");
                        return null;
                    }
                    configuration = pageModel.page;
                } else {
                    configuration = getConfigurationForPath(path, pageModel);
                    if (configuration && renderComponent) {
                        return this.renderStaticComponent(renderComponent, configuration, pageModel);
                    }
                }
                if (!configuration) {
                    return null;
                }
                return this.renderPageComponent(configuration, renderComponent);
            }
        } ]);
        return RenderCmsComponent;
    }(React.Component);
    var renderCmsComponent = withPageModel(RenderCmsComponent);
    function isString(value) {
        return typeof value === "string" || value instanceof String;
    }
    function _createLink(linkType, link, linkText, className, externalCreateLinkFunction, pageModel) {
        var href = null;
        var internalLink = null;
        switch (linkType) {
          case "self":
            href = getNestedObject(link, [ "_links", "site", "href" ]);
            internalLink = getNestedObject(link, [ "_links", "site", "type" ]);
            break;

          case "ref":
            if (!link || !isString(link)) {
                break;
            }
            var linkedContent = jsonpointer.get(pageModel, link);
            if (linkedContent) {
                href = getNestedObject(linkedContent, [ "_links", "site", "href" ]);
                internalLink = getNestedObject(linkedContent, [ "_links", "site", "type" ]);
            }
            break;

          case "href":
            href = link;
            internalLink = "internal";
            break;
        }
        if (href && internalLink && typeof linkText === "function") {
            return internalLink === "internal" && typeof externalCreateLinkFunction === "function" ? externalCreateLinkFunction(href, linkText, className) : React.createElement("a", {
                className: className,
                href: href
            }, linkText());
        }
        return null;
    }
    function createLink(linkType, link, linkText, className) {
        return React.createElement(PageModelContext.Consumer, null, (function(pageModel) {
            return React.createElement(CreateLinkContext.Consumer, null, (function(externalCreateLinkFunction) {
                return _createLink(linkType, link, linkText, className, externalCreateLinkFunction, pageModel);
            }));
        }));
    }
    var MONTHS = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
    function parseDate(date) {
        var parsedDate = parseFloat(date);
        if (isNaN(parsedDate)) {
            return null;
        }
        var dateObj = new Date(parsedDate);
        return "".concat(MONTHS[dateObj.getMonth()], " ").concat(dateObj.getDate(), ", ").concat(dateObj.getFullYear());
    }
    function getImageUrl(imageRef, pageModel, preview, variant) {
        var imageUuid;
        if (imageRef && imageRef.$ref) {
            imageUuid = imageRef.$ref;
        }
        var image;
        if (imageUuid && (typeof imageUuid === "string" || imageUuid instanceof String)) {
            image = jsonpointer.get(pageModel, imageUuid);
        }
        var imageUrl = variant && getNestedObject(image, [ variant ]) ? getNestedObject(image, [ variant, "_links", "site", "href" ]) : getNestedObject(image, [ "_links", "site", "href" ]);
        if (imageUrl && !imageUrl.match(FULLY_QUALIFIED_LINK)) {
            imageUrl = cmsUrls[preview ? "preview" : "live"].baseUrl + imageUrl;
        }
        return imageUrl;
    }
    function getImageUrlByPath(imagePath, variant, preview) {
        var cmsUrls$1 = cmsUrls[preview ? "preview" : "live"];
        var imageUrl = cmsUrls$1.baseUrl;
        if (cmsUrls$1.contextPath) {
            imageUrl += "/".concat(cmsUrls$1.contextPath);
        }
        imageUrl += "/binaries";
        if (variant) {
            imageUrl += "/".concat(variant);
        }
        imageUrl += imagePath;
        return imageUrl;
    }
    function getChildren(node) {
        if (!node.children) {
            return "";
        }
        return node.children.reduce((function(linkText, childNode) {
            return linkText + getChildren(childNode) + (childNode.type === "text" ? childNode.data : "");
        }), "");
    }
    function parseAndRewriteLinks(html, preview) {
        return ReactHtmlParser(html, {
            transform: function transform(node) {
                if (node.type === "tag" && node.name === "a" && node.attribs["data-type"] && node.attribs["data-type"] === "internal") {
                    var _node$attribs = node.attribs, className = _node$attribs["class"], href = _node$attribs.href;
                    var linkText = function linkText() {
                        return getChildren(node);
                    };
                    var link = createLink("href", href, linkText, className);
                    return React.cloneElement(link, {
                        key: node.parent ? node.parent.children.indexOf(node) : 0
                    });
                }
                if (node.type === "tag" && node.name === "img" && node.attribs.src && !node.attribs.src.match(FULLY_QUALIFIED_LINK)) {
                    var baseCmsUrl = cmsUrls[preview ? "preview" : "live"].baseUrl;
                    node.attribs.src = baseCmsUrl + node.attribs.src;
                }
            }
        });
    }
    exports.CmsEditButton = CmsEditButton;
    exports.CmsPage = CmsPage;
    exports.ContentComponentWrapper = ContentComponentWrapper;
    exports.Placeholder = Placeholder;
    exports.RenderCmsComponent = renderCmsComponent;
    exports.createLink = createLink;
    exports.getApiUrl = getApiUrl;
    exports.getImageUrl = getImageUrl;
    exports.getImageUrlByPath = getImageUrlByPath;
    exports.getNestedObject = getNestedObject;
    exports.parseAndRewriteLinks = parseAndRewriteLinks;
    exports.parseDate = parseDate;
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
}));
//# sourceMappingURL=bloomreach-experience-react-sdk.js.map
